<template>
	<div>
		<j-base-select
			:id="id"
			:options="options"
			:value="value"
			:status="status"
			nameKey="name"
			:placeholder="$t('select_role')"
			textKey="description"
			valueKey="id"
			@input="onInput($event)"
		/>
		<div v-if="error && !isLoading" class="fs3 cError">{{ error }}</div>
		<div v-if="isLoading" class="fs3">{{ $t("loading") }}...</div>
	</div>
</template>

<script>
import JBaseSelect from "@/components/JBaseSelect/"
import api from "../api/"

export default {
	components: { JBaseSelect },
	props: {
		value: {
			validator(value) {
				return value === null || typeof value === "string"
			},
			required: true,
			default: null
		},
		id: {
			type: String,
			required: false
		},
		status: {
			type: String,
			required: false
		}
	},
	data() {
		return {
			options: [],
			isLoading: false,
			error: null
		}
	},

	methods: {
		onInput(value) {
			this.$emit("input", value)
		}
	},

	async mounted() {
		this.isLoading = true
		const res = await api.permissionGroups()

		if (res.errors) {
			res.errors.forEach(err => (this.error = err))
		} else this.options = res.data.permissionGroups

		this.isLoading = false
	}
}
</script>
